import React from "react";
import NavBar from "../Components/NavBar";
import Jumbotron from "../Components/Jumbotron";
function Header() {
  return (
<>
<div className='mb-3 app-header'>
<Jumbotron />

<NavBar/>
</div>
</>
)}

export default Header;

